import React from 'react';
import config from 'config';
import Table from 'components/table';
import styled from 'styled-components';

const StatusesWrapper = styled.div`
	display: inline-block;
`;

const operations = {
  'create': (
    <StatusesWrapper>Створення</StatusesWrapper>
  ),
  'edit': (
    <StatusesWrapper>Редагування</StatusesWrapper>
  ),
  'delete': (
    <StatusesWrapper>Виделення</StatusesWrapper>
  ),
  'activation': (
    <StatusesWrapper>Активація</StatusesWrapper>
  )
}

export const MailJournal = ({ journal }) => (
  <Table black>
    <thead>
      <tr>
        <th>Номер дії</th>
        <th>Автор дії</th>
        <th>Дата дії</th>
        <th>Тип дії</th>
      </tr>
    </thead>
    <tbody>
      {journal.map((item, i) => (
        <tr key={i}>

          <td><span>Номер дії:</span>{item.get('id')}</td>
          <td><span>Автор дії:</span>{item.get('author_data').get('first_name')} {item.get('author_data').get('last_name')}</td>
          <td><span>Дата дії:</span>{new Date(item.get('time_activation')).toLocaleString('uk-UA', config.options)}</td>
          <td><span>Тип дії:</span>{operations[item.get('type_operation')]}</td>

        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/admin/mailing/detail/mail-journal.js